var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: _vm.formName,
      attrs: { model: _vm.form, rules: _vm.rules },
      nativeOn: {
        submit: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [
      _vm.error
        ? _c("el-alert", {
            attrs: {
              title: "Authentication failed",
              type: "error",
              description: _vm.error,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "Token", "inline-message": true, prop: "token" } },
        [
          _c("el-input", {
            attrs: { size: "medium" },
            model: {
              value: _vm.form.token,
              callback: function ($$v) {
                _vm.$set(_vm.form, "token", $$v)
              },
              expression: "form.token",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("span", { staticClass: "text-muted" }, [
        _vm._v("Your token expires in 2 minutes"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-action" },
        [
          _c(
            "el-button",
            {
              staticClass: "btn-submit",
              attrs: { type: "primary", disabled: _vm.loading },
              on: {
                click: function ($event) {
                  return _vm.submitForm()
                },
              },
            },
            [_vm._v("Continue")]
          ),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "token-footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "text" }, on: { click: _vm.forgotPhone } },
                [_vm._v("Click here")]
              ),
              _vm._v(
                "\n      if you have a new mobile number and would like to update your member record.\n      If you do not have access to your mobile number then please call 02 8356 0300.\n    "
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }